import { Checkbox, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { useGridData } from "src/context/GridContext/GridContext";
import Report_ReportComponent_KuskiVehicleHeader from "../reportComponents/Report_ReportComponent_KuskiVehicleHeader";
import Report_ReportComponent_Keikka from "../reportComponents/Report_ReportComponent_Keikka";
import { useReportData } from "src/context/ReportContext";
import { useUserData } from "src/context/userContext";
import { pvmStringLong } from "src/components/js/statics1";
import ProgressBar from "src/components/layout/Progress/ProgressBar";

export default function Report_KuljettajaTilaukset() {
  const { userAsiakas } = useUserData();
  const {
    dailyKeikat,
    dailyPalkit,
    drivers,
    vehicleLookup,
    time,
    isLoading: isGridLoading,
  } = useGridData();
  const { settingsData, setSettingsData } = useReportData();
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);
  const [kuskit, setKuskit] = useState([]);

  const paperColor = theme.palette.background.paper;

  useEffect(() => {
    if (!userAsiakas) return;
    document.title =
      "Report " + userAsiakas.asiakasNimi + " tilaukset " + time.starttime
        ? pvmStringLong(time.starttime)
        : "";
  }, [userAsiakas, time.starttime]);

  useEffect(() => {
    if (!userAsiakas) return;
    if (!drivers || !dailyKeikat) return;
    let _kuskit = [];
    setIsLoading(true);
    for (let i = 0; i < drivers.length; i++) {
      const _kuski = drivers[i];
      _kuski.keikat = [];
      _kuski.vehicles = [];
      // find kuski in dailyKeikat
      for (let j = 0; j < dailyKeikat.length; j++) {
        for (let k = 0; k < dailyKeikat[j].kuskit.length; k++) {
          if (dailyKeikat[j].kuskit[k].personId === _kuski.personId) {
            // add keikka to kuskit
            _kuski.keikat.push(dailyKeikat[j]);
            // add vehicle to kuski if not already there
            let vehicleFound = false;
            for (let l = 0; l < _kuski.vehicles.length; l++) {
              if (_kuski.vehicles[l].vehicleId === dailyKeikat[j].vehicleId) vehicleFound = true;
            }
            if (!vehicleFound) _kuski.vehicles.push(vehicleLookup[dailyKeikat[j].vehicleId]);
          }
        }
      }
      // find kuski in dailyPalkit and add palkki to kuskit
      for (let j = 0; j < dailyPalkit.length; j++) {
        const _vehicleId = dailyPalkit[j].vehicleId;
        if (_kuski.vehicles.length === 0) continue;
        for (let k = 0; k < _kuski.vehicles.length; k++) {
          if (_kuski.vehicles[k].vehicleId === _vehicleId) {
            if (!_kuski.keikat.some((keikka) => keikka.keikkaId === dailyPalkit[j].keikkaId))
              _kuski.keikat.push(dailyPalkit[j]);
          }
        }
      }
      // order keikat by timeStart then by keikkaId
      _kuski.keikat.sort((a, b) => {
        if (a.timeStart < b.timeStart) return -1;
        if (a.timeStart > b.timeStart) return 1;
        if (a.keikkaId < b.keikkaId) return -1;
        if (a.keikkaId > b.keikkaId) return 1;
        return 0;
      });
      if (_kuski.keikat.length > 0) _kuskit.push(_kuski);
    }
    setKuskit(_kuskit);
    setIsLoading(false);
  }, [drivers, dailyKeikat]);

  return (
    <div
      style={{
        paddingLeft: "20px",
        paddingRight: "20px",
        display: "flex",
        flexDirection: "column",
        gap: settingsData?.driverSpacing || 1,
        backgroundColor: paperColor,
        position: "relative",
      }}>
      <div
        className="noPrint onlyWide harmaaTausta"
        style={{
          border: "1px solid gray",
          padding: 5,
          position: "absolute",
          top: 0,
          right: 0,
          zIndex: 1000,
        }}>
        <Checkbox
          checked={settingsData.usePageBreaks_driver || false}
          onChange={(e) =>
            setSettingsData({ ...settingsData, usePageBreaks_driver: e.target.checked })
          }
          color="primary"
          size="small"
        />
        Sivunvaihto kuljettajan jälkeen{" "}
      </div>
      {(isLoading || isGridLoading) && <ProgressBar show height={4} />}
      {kuskit.map((kuski) => (
        <div
          key={kuski.personId}
          style={{
            display: "flex",
            flexDirection: "column",
            pageBreakAfter: settingsData.usePageBreaks_driver ? "always" : "auto",
          }}>
          <Report_ReportComponent_KuskiVehicleHeader kuski={kuski} mainComponent="kuski" />
          {kuski.keikat.map((keikka) => (
            <Report_ReportComponent_Keikka
              key={kuski.personId + "_" + keikka.keikkaId}
              keikka={keikka}
              vehicle={vehicleLookup[keikka.vehicleId]}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
